import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { store } from 'redux-rest-reducer';
import styled from 'styled-components';

import { Text, Separator, Button } from '@cuemath/comps';

import { post as recordOfflinePayment } from 'actions/offline-payment';
import { openModal, closeModal } from 'actions/modal';

import {
  Footer,
  Message,
  FormWrapper,
  ButtonWrapper,
  HeaderHead,
  FieldWrapper,
  Field,
  Label,
} from 'modules/form';
import { MODAL_FORM } from 'constants/form';
import MODAL from 'constants/modal';
import CourseInfo from './course-info-view';
import AddonInfo from './addon-info-view';
import { Rectangle } from 'styled-icons/boxicons-regular';

const HeaderHeadWrapper = styled(HeaderHead)`
  padding: 10px 10px 10px 10px;
`;

const LabelText = styled(Label)`
  font-weight: 800;
`;

const LabelValue = styled(Label)`
  min-width: 50%;
  margin-left: 30px;
`;

class PaymentConfirmationModal extends PureComponent {
  static defaultProps = {
    paymentData: null,
  };

  static propTypes = {
    actions: PropTypes.shape({
      recordOfflinePayment: PropTypes.func.isRequired,
    }).isRequired,
    paymentData: PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      errorText: null,
      message: null,
      paymentLinkPost: store.post(),
      updateList: true,
    };
  }

  static getDerivedStateFromProps(props, state) {
    const newState = {};
    const { offlinePaymentLink } = props;
    const { paymentLinkPost } = state;
    const newPaymentLinkPost = store.post(offlinePaymentLink, paymentLinkPost.id);

    if (newPaymentLinkPost.resolved) {
      if (newPaymentLinkPost.resolved.isCreated) {
        newState.SlotPost = newPaymentLinkPost;
        newState.message = 'Payment Link saved successfully';
        newState.errorText = null;
      } else if (newPaymentLinkPost.resolved.isCreatingFailed) {
        newState.SlotPost = newPaymentLinkPost;
        newState.errorText = store.getError(newPaymentLinkPost.resolved).message;
        newState.message = null;
      }
    }

    return newState;
  }

  GeneratePayment = e => {
    e.preventDefault();
    const { actions, paymentData } = this.props;
    const {
      paymentLinkPost: { id },
    } = this.state;

    let data = { ...paymentData };
    delete data.course;
    delete data.class_ratio;
    delete data.access_type;
    delete data.addonsInfo;

    data['duration'] = paymentData.courses[0].duration; //selecting first course duration
    data['teacher_id'] = paymentData['teacher_id'];
    actions.recordOfflinePayment(id, data, { studentId: paymentData.id });
  };

  Cancel = e => {
    e.preventDefault();
    const { actions, paymentData } = this.props;
    actions.openModal(
      MODAL_FORM.PAYMENT_DATA_UPLOAD_MODAL,
      {
        size: 'custom',
        width: `${Math.ceil((window.innerWidth * 50) / 100)}px`,
        height: MODAL.HEIGHT,
      },
      { student: paymentData },
    );
  };

  renderFormHeader = () => {
    return (
      <HeaderHeadWrapper>
        <Text size="xlarge" align="center">
          Confirm
        </Text>
      </HeaderHeadWrapper>
    );
  };

  renderAddonDetailsview = () => {
    const { paymentData } = this.props;
    return (
      <React.Fragment>
        <Separator transparent height="10" />
        <AddonInfo addonInfo={paymentData.addonsInfo} />
        <Separator transparent height="10" />
      </React.Fragment>
    );
  };

  renderCourseDetailsview = () => {
    const { paymentData } = this.props;
    return (
      <React.Fragment>
        <Separator transparent height="10" />
        <CourseInfo courseInfo={paymentData.courses} />
        <Separator transparent height="10" />
      </React.Fragment>
    );
  };

  renderFormFields = () => {
    const { paymentData, selectedTeacherDetails } = this.props;

    return (
      <React.Fragment>
        {this.renderCourseDetailsview()}
        {this.renderAddonDetailsview()}
        {paymentData && Object.keys(paymentData).length ? (
          <FieldWrapper>
            <Field>
              <LabelText>Student id</LabelText>
              <LabelValue>{paymentData['student_id']}</LabelValue>
            </Field>
            <Field>
              <LabelText>Currency</LabelText>
              <LabelValue>{paymentData['currency']}</LabelValue>
            </Field>
            <Field>
              <LabelText>Amount</LabelText>
              <LabelValue>{paymentData['amount']}</LabelValue>
            </Field>
            <Field>
              <LabelText>City</LabelText>
              <LabelValue>{paymentData['city']}</LabelValue>
            </Field>
            {paymentData.currency === 'INR' && (
              <React.Fragment>
                <Field>
                  <LabelText>State</LabelText>
                  <LabelValue>{paymentData['state']}</LabelValue>
                </Field>
                <Field>
                  <LabelText>Pin Code</LabelText>
                  <LabelValue>{paymentData['pincode']}</LabelValue>
                </Field>
              </React.Fragment>
            )}
            <Field>
              <LabelText>Country</LabelText>
              <LabelValue>{paymentData['country']}</LabelValue>
            </Field>
            <Field>
              <LabelText>Payment Client</LabelText>
              <LabelValue>{paymentData['payment_client']}</LabelValue>
            </Field>
            <Field>
              <LabelText>Paid On</LabelText>
              <LabelValue>
                {new Date(paymentData['paid_on'] * 1000).toDateString()}
              </LabelValue>
            </Field>
            <Field>
              <LabelText>Invoice id</LabelText>
              <LabelValue>{paymentData['invoice_id']}</LabelValue>
            </Field>
            <Field>
              <LabelText>Assigned Teacher</LabelText>
              <LabelValue>{selectedTeacherDetails}</LabelValue>
            </Field>
          </FieldWrapper>
        ) : (
          <Text align="center">No data</Text>
        )}
      </React.Fragment>
    );
  };

  renderFormFooter = () => {
    return (
      <Footer>
        <ButtonWrapper flex-direction="column">
          <Button label="Generate" onClick={this.GeneratePayment} />
          <Button label="Cancel" onClick={this.Cancel} />
        </ButtonWrapper>
      </Footer>
    );
  };

  render() {
    const { errorText, message, form } = this.state;

    return (
      <form>
        <FormWrapper>
          {this.renderFormHeader()}
          <Separator transparent height="25" />
          {this.renderFormFields()}
          {errorText && <Message error={true}>{errorText}</Message>}
          {message && <Message>{message}</Message>}
          <Separator transparent height="30" />
          {this.renderFormFooter()}
          <Separator transparent height="30" />
        </FormWrapper>
      </form>
    );
  }
}

export default connect(
  ({ offlinePaymentLink }) => ({ offlinePaymentLink }),
  dispatch => ({
    actions: bindActionCreators(
      {
        recordOfflinePayment,
        openModal,
        closeModal,
      },
      dispatch,
    ),
  }),
)(PaymentConfirmationModal);
